export default "./50f98ae48700ceb1d862eec02ec60b79.svg";